import {DataGrid, ResourceCellRenderer} from "../../directives";
import {SearchExpression} from '../../model/search/advanced/SearchExpression';
import {ResourceEntityType, ResourceEntityTypeUtils} from '../../model/resources/ResourceEntityType';
import {
  CollectionService,
  Factory,
  INotificationService,
  OrganizationService,
  PostProcessingMetricsService,
  PreferenceService,
  PreProcessingMetricsService,
  ProcessingService,
  ProjectService,
  ResourceService,
  TrackService
} from '../../services';
import {DisplayMode, Preferences} from '../../model/user/Preferences';
import {CollectionStatus} from '../../model/collections/Collection';
import {Status} from '../../model/project/Status';
import {IRootScope} from '../../IRootScope';
import {SearchService as BasicSearchService} from '../../services/search/basic/SearchService';
import {IScope} from "angular";

export interface ICollectionControllerScope extends IScope {
  organization: any;
  project: any;
  collection: any;
  collections: any[];
  resourcesPage: any;
  chart: any;
  preprocessing: any;
  postprocessing: any;
  pagination: {
    limit: number,
    filterString: string
  },
  search: { query: string },
  view: {
    selected: any[],
    searching: boolean
  },
  collectionSourceSize: any;
  collectionOutputSize: any;
  secondsProcessing: number;
  cookieFilter: any;
  progress: any;
  processingComplete: any;
  showFilteredCollections: Function;
  openPreProcessingReportDialog: Function;
  openNewCollectionDialog: Function;
  cursor: any;
  math: any;
  displayMode: any;
  DisplayMode: any;
  gridViewDataSource: agGrid.IDatasource;
  listViewDataSource: agGrid.IDatasource;
  gridViewColumnDefinitions: any[];
  listViewColumnDefinitions: any[];
  totalResources: number;
  totalPageCount: number;
  totalFileSize: number;
  sortModel: any;
  filterModel: any;
  ListViewCellRenderer: any;
  columnFilters: SearchExpression;
}

export class CollectionController {
  constructor(private scope: ICollectionControllerScope, rootScope: IRootScope, modal, private routeParams, private $timeout: angular.ITimeoutService, private organizationService: OrganizationService, private projectService: ProjectService, private collectionService: CollectionService, private resourceService: ResourceService, cursorService: any, layerService: any, private preProcessingMetricsService: PreProcessingMetricsService, private postProcessingMetricsService: PostProcessingMetricsService, navigationService: any, private preferenceService: PreferenceService, trackService: TrackService, private notificationService: INotificationService, processingService: ProcessingService) {
    this.scope.DisplayMode = DisplayMode;
    this.scope.CollectionStatus = CollectionStatus;
    this.scope.Status = Status;
    this.scope.ListViewCellRenderer = ResourceCellRenderer;
    scope.ResourceEntityType = ResourceEntityType;
    scope.resourceEntityTypes = ResourceEntityTypeUtils.ResourceEntityTypes;
    scope.resourceEntityType = {id: ResourceEntityType.Person, name: "Person"};

    scope.searchDocuments = () => {
      rootScope.$broadcast("BasicSearch.Triggered", "createdDate:" + BasicSearchService.FormatDateSearch({
        min: scope.chart.startDate,
        max: scope.chart.endDate
      }));
    };

    scope.setResourceEntityType = async item => {
      const fieldName = item.name.replace(" ", "").replace(item.name[0], item.name[0].toLowerCase());
      scope.resourceEntityType = item;

      scope.postprocessing.namedEntities = await postProcessingMetricsService.GetNamedEntities(routeParams.projectId, fieldName, routeParams.collectionId);
      scope.$applyAsync();
    };

    if (!(this.scope.displayMode = preferenceService.Get(Preferences.DISPLAY_MODE))) {
      preferenceService.Set(Preferences.DISPLAY_MODE, DisplayMode.ListView);
      this.scope.displayMode = preferenceService.Get(Preferences.DISPLAY_MODE);
    }
    this.scope.sortModel = preferenceService.Get(Preferences.GRID_COLUMNS_SORT_MODEL);
    this.scope.pagination = {
      limit: scope.displayMode === DisplayMode.ListView ? 20 : 200,
      filterString: ""
    };
    this.scope.filterModel = preferenceService.Get(Preferences.GRID_COLUMNS_FILTER_MODEL);
    this.scope.math = Math;
    this.scope.cursor = cursorService;
    this.scope.progress = {
      numQueued: 100,
      numProcessed: 50
    };
    this.scope.search = {
      query: ""
    };
    this.scope.view = {
      selected: [],
      searching: false
    };
    this.scope.collectionSourceSize = {value: 0, total: 0};
    this.scope.collectionOutputSize = {value: 0, total: 0};
    this.scope.preprocessing = {
      selected: true,
      selection: "Extension",
      selections: ["Extension", "Category"]
    };
    this.scope.postprocessing = {
      selection: "Extension",
      selections: ["Extension", "Category"],
      update: (value: any) => {
        scope.postprocessing.communicationPatterns = postProcessingMetricsService.GetCommunicationPatterns(routeParams.projectId, value, routeParams.collectionId);
      }
    };

    this.scope.initialPageLoading = true;

    navigationService.setActiveTab("projects");

    this.LoadProject();

    this.LoadCollection();

    this.LoadProcessingMetrics();

    this.scope.openNewCollectionDialog = () => {
      modal.open({
        backdrop: true,
        keyboard: true,
        backdropClick: true,
        templateUrl: "partials/dialog_collection.html",
        controller: "AddCollectionController",
        scope: this.scope,
        resolve: {
          project: () => this.scope.project
        },
        windowClass: "iio-large-modal"
      });
    };

    this.scope.openPreProcessingReportDialog = () => {
      let currentDate = new Date();

      modal.open({
        backdrop: true,
        keyboard: true,
        backdropClick: true,
        templateUrl: "partials/reporting/dialog_report.html",
        controller: "AddReportModalCtrl",
        scope: this.scope,
        resolve: {
          project: () => scope.project,
          config: () => {
            return {
              type: "pre_processing_report",
              format: "zip",
              name: `Pre Processing Report ${(currentDate.getMonth() + 1)}/${currentDate.getDate()}/${currentDate.getFullYear()} @ ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`,
              fields: [] as any
            };
          },
          formConfig: () => {
            return {
              hideFields: true
            }
          },
          collections: () => [this.scope.collection.id],
          search: null,
          filter: scope.cookieFilter
        }
      });
    };

    scope.resumeCollectionProcessing = (collection: any) => {
      (collection as any).resuming = true;
      processingService.ResumeProcessing(collection, () => {
        console.log('SUCCESS! ' + collection);
        notificationService.addSuccess({
          title: 'Resuming collection processing',
          description: '',
          timeout: 5000
        });
      }, () => {
        notificationService.addError({
          title: 'Error resuming collection processing',
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });
      });
    };

    scope.activateProject = () => {
      modal.open({
        backdrop: 'static',
        keyboard: true,
        backdropClick: false,
        templateUrl: 'partials/dialog_credit_card.html',
        controller: 'CreditCardModalController',
        scope: scope,
        resolve: {
          project: () => scope.project,
          message: () => "Activate account to resume processing"
        }
      });
    };

    this.scope.$on("DataGridRowSelectedEvent", (e, params) => {
      trackService.TrackEvent("full view link", "clicked");
      let {projectId, collectionId, id} = params.data;

      resourceService.LaunchFullView({
        projectId,
        collectionId,
        resourceId: id,
        grid: params.grid,
        index: params.index
      });
    });

    this.scope.$on("DataGridSortChangedEvent", (e, sort) => {
      preferenceService.Set(Preferences.GRID_COLUMNS_SORT_MODEL, sort);
    });

    this.scope.$on("DataGridFilterChangedEvent", (e, filter) => {
      preferenceService.Set(Preferences.GRID_COLUMNS_FILTER_MODEL, filter);
      scope.columnFilters = DataGrid.GetSearchExpressionFromFilterModel(filter);
    });

    this.scope.$on("DataGridColumnsChangedEvent", (e, columns) => {
      preferenceService.Set(Preferences.GRID_COLUMNS, columns);
    });

    this.scope.$on("DataGridColumnsResetEvent", () => {
      preferenceService.ResetGridPreferences();
      this.scope.$broadcast("fetchResources");
    });

    this.scope.$on("DataGridRowCheckedEvent", (e, params) => {
      this.scope.resources = _.map(params.grid.api.getSelectedRows(), (r: any) => r.id);
    });

    this.scope.$on(PreferenceService.GetEventForPreference(Preferences.DISPLAY_MODE), (e: any, value: any) => {
      preferenceService.Set(Preferences.DISPLAY_MODE, value);
      this.scope.displayMode = value;
      this.RefreshResourceView();
    });

    this.scope.$on("fetchResources", () => this.RefreshResourceView());

    this.scope.$on("chartItemSelected", (e, sender, item) => {
      if (sender.attr("id").indexOf("collection") >= 0 || sender.attr("id").indexOf("custodian") >= 0) {
        this.scope.showFilteredCollections(item);
      } else if (sender.attr("id").indexOf("extension") >= 0) {
        rootScope.$broadcast("BasicSearch.Triggered", `fileExtension:"${item.id}"`);
      } else if (sender.attr("id").indexOf("category") >= 0) {
        rootScope.$broadcast("BasicSearch.Triggered", `category:"${item.id}"`);
      } else if (sender.attr("id").indexOf("emailDomain") >= 0) {
        rootScope.$broadcast("BasicSearch.Triggered", `emailDomains:"${item.id}"`);
      } else if (sender.attr("id").indexOf("systemTagChart") >= 0) {
        rootScope.$broadcast("BasicSearch.Triggered", `systemTags:"${item.id}"`);
      } else if (sender.attr("id").indexOf("resourceEntities") >= 0) {
        rootScope.$broadcast("BasicSearch.Triggered", `${item.type}Entities.lowercase:"${item.id}"`);
      } else if (sender.attr("id").indexOf("timeline") >= 0) {
        rootScope.$broadcast("BasicSearch.Triggered", "createdDate:" + BasicSearchService.FormatDateSearch(item));
      }
    });

    this.scope.$on("FeedService.processorInit", (event, message) => {
      if (message.id === routeParams.collectionId) {
        scope.progress.isInitializing = true;
      }
    });

    this.scope.$on("FeedService.ProcessingStart", (event, message) => {
      if (message.collectionId === routeParams.collectionId) {
        scope.collection.processingStart = message.processingStart;
      }
    });

    this.scope.$on("FeedService.ProcessingPaused", (event, message) => {
      this.notificationService.addInfo({
        title: 'Collection Processing Paused',
        description: `Collection ${message.name} was paused because you've exceeded the allowed 5GB data limit on your trial account, please activate to resume processing.`,
        timeout: 5000
      });

      scope.collection.status = CollectionStatus.Paused;

    });

    this.scope.$on("FeedService.ProcessingEnd", (event, message) => {
      if (message.id === routeParams.collectionId) {
        postProcessingMetricsService.GetAllMetrics(routeParams.projectId, routeParams.collectionId).then((data: any) => {
          scope.chart = {};
          scope.chart.resourceCounts = data.documentCountByDate;
          scope.chart.start = data.startDate;
          scope.chart.end = data.endDate;
          scope.postprocessing.communicationPatterns = data.communicationPatterns;
          scope.postprocessing.extensionByCount = data.extensionByCount;
          scope.postprocessing.extensionBySize = data.extensionBySize;
          scope.postprocessing.typeByCount = data.typeByCount;
          scope.postprocessing.typeBySize = data.typeBySize;
          scope.postprocessing.documentCountByDate = data.documentCountByDate;
          scope.postprocessing.systemTags = data.systemTags;
          scope.postprocessing.emailDomains = data.emailDomains;

          scope.collection.processingEnd = message.processingEnd;
          scope.collection.status = CollectionStatus.Processed;
        });
      }
    });

    this.scope.$on("FeedService.CollectionUpdate", (event, message) => {
      const percentageComplete = Math.max(Math.floor(message.numProcessed / message.numQueued * 100), 0);

      if (message.collectionId == routeParams.collectionId) {
        scope.collection = {
          ...scope.collection,
          status: message.status,
          numQueued: message.numQueued,
          numProcessed: message.numProcessed,
          bytesProcessed: message.bytesProcessed,
          processingSource: message.processingSource,
          processingOutput: message.processingOutput,
          job: {...scope.collection.job, percentageComplete},
          pdfQueued: message.pdfQueued,
          nlpQueued: message.nlpQueued,
          ocrQueued: message.ocrQueued,
          audioQueued: message.audioQueued
        };
        if (scope.collectionSourceSize.value !== message.processingSource.bytes || scope.collectionOutputSize.value !== message.processingOutput.bytes) {
          scope.collectionSourceSize = {
            value: message.processingSource.bytes,
            total: message.processingSource.bytes + message.processingOutput.bytes
          };
          scope.collectionOutputSize = {
            value: message.processingSource.bytes + message.processingOutput.bytes,
            total: message.processingSource.bytes + message.processingOutput.bytes
          };
        }
      }
    });

    this.scope.$watch("collection.processingEnd - collection.processingStart", (processingMilliseconds: number) => {
      if (processingMilliseconds) {
        this.scope.secondsProcessing = Math.floor(processingMilliseconds / 1000);
      }
    });

    this.scope.$watch("collection.numQueued + collection.numProcessed", (newVal: number) => {
      if (newVal && newVal > 0) {
        scope.processingComplete = (
          scope.collection &&
          scope.collection.numQueued > 0 &&
          scope.collection.numQueued == scope.collection.numProcessed
        );
      }
    }, true);

    rootScope.$on('LayerService.hide_' + layerService.LAYERS.SEARCH, () => {
      this.RefreshResourceView();
    });

  }

  private async LoadProject() {
    this.scope.project = await this.projectService.FindOneOrCurrentProject({id: this.routeParams.projectId});

    if (this.scope.project.type === "organization_project") {
      this.scope.organization = await this.organizationService.FindOne({id: this.scope.project.organizationId});
    }

    this.projectService.SetCurrentProject(this.scope.project);
  }

  private async LoadCollection() {
    const collection = await this.collectionService.FindOne({
      id: this.routeParams.collectionId,
      projectId: this.routeParams.projectId
    });

    this.scope.collection = collection;
    this.scope.collections = [collection];
    this.collectionService.SetCurrentCollection(collection);

    this.scope.collectionSourceSize = {
      value: collection.processingSource.bytes,
      total: collection.processingSource.bytes + collection.processingOutput.bytes
    };
    this.scope.collectionOutputSize = {
      value: collection.processingSource.bytes + collection.processingOutput.bytes,
      total: collection.processingSource.bytes + collection.processingOutput.bytes
    };
  }

  private async LoadProcessingMetrics() {
    const promise1 = this.preProcessingMetricsService.GetAllMetrics(this.routeParams.projectId, this.routeParams.collectionId);
    const promise2 = this.postProcessingMetricsService.GetAllMetrics(this.routeParams.projectId, this.routeParams.collectionId);

    const [preProcessingMetrics, postProcessingMetrics] = await Promise.all([promise1, promise2]);

    this.$timeout(() => {
      // Preserve all UI control state — do NOT let API data overwrite tab selection or callbacks.
      const {selected: preSelected, selection: preSelection, selections: preSelections} = this.scope.preprocessing;
      this.scope.preprocessing = {
        ...preProcessingMetrics,
        selected: preSelected,
        selection: preSelection,
        selections: preSelections
      };

      const {
        selected: postSelected,
        selection: postSelection,
        selections: postSelections,
        update: postUpdate
      } = this.scope.postprocessing;
      this.scope.postprocessing = {
        ...postProcessingMetrics,
        selected: postSelected,
        selection: postSelection,
        selections: postSelections,
        update: postUpdate
      };

      this.scope.chart = {};
      this.scope.chart.resourceCounts = postProcessingMetrics.documentCountByDate;
      this.scope.chart.start = postProcessingMetrics.startDate;
      this.scope.chart.end = postProcessingMetrics.endDate;
    });
  }

  private RefreshResourceView() {
    const self = this;
    const dataSource = {
      rowCount: null,
      getRows(params: agGrid.IGetRowsParams) {
        self.resourceService.FindAll({
          collectionId: self.routeParams.collectionId,
          projectId: self.routeParams.projectId,
          page: Math.floor(params.startRow / self.scope.pagination.limit),
          limit: self.scope.pagination.limit,
          tagFilter: self.scope.pagination.filterString || "",
          columnFilters: DataGrid.GetSearchExpressionFromFilterModel(self.preferenceService.Get(Preferences.GRID_COLUMNS_FILTER_MODEL)),
          sortBy: params.sortModel.length > 0 ? params.sortModel[0].colId : null,
          sortDirection: params.sortModel.length > 0 ? params.sortModel[0].sort.toUpperCase() : null
        }).then((resourcesPage: any) => {
          self.scope.initialPageLoading = false;
          self.scope.totalResources = resourcesPage.totalResources;
          self.scope.totalPageCount = resourcesPage.totalPageCount;
          self.scope.totalFileSize = resourcesPage.totalFileSize;
          params.successCallback(resourcesPage.resources, resourcesPage.totalResources);
        }).catch(() => {
          self.scope.totalResources = 0;
          self.scope.totalPageCount = 0;
          self.scope.totalFileSize = 0;
        });
      }
    };

    this.scope.sortModel = this.preferenceService.Get(Preferences.GRID_COLUMNS_SORT_MODEL);
    this.scope.filterModel = this.preferenceService.Get(Preferences.GRID_COLUMNS_FILTER_MODEL);

    if (this.preferenceService.Get(Preferences.DISPLAY_MODE) == DisplayMode.ListView) {
      this.scope.listViewColumnDefinitions = this.preferenceService.Get(Preferences.GRID_COLUMNS);
      this.scope.listViewDataSource = dataSource;
    } else {
      this.scope.gridViewColumnDefinitions = this.preferenceService.Get(Preferences.GRID_COLUMNS);
      this.scope.gridViewDataSource = dataSource;
    }
  }
}

frontendApp.controller("CollectionController", ["$scope", "$rootScope", "$uibModal", "$routeParams", "$timeout", "OrganizationService", "ProjectService", "CollectionService", "ResourceService", "CursorService", "LayerService", "PreProcessingMetricsService", "PostProcessingMetricsService", "NavigationService", "PreferenceService", "TrackService", "NotificationService", "ProcessingService", Factory.Create(CollectionController)]);
